import { Injectable } from '@angular/core';

@Injectable()
export class TranslationService {
  private translations: {};

  constructor() {
    this.translations = {
      'Unable to login with provided credentials.':
        'Klarte ikke å logge inn med den oppgitte informasjonen',
    };
  }

  public translate(key) {
    if (this.translations[key]) {
      return this.translations[key];
    }

    return key;
  }
}
